// extracted by mini-css-extract-plugin
module.exports = {"category":"FlagDetailsCategory-category-4bf455ca4ed87c7378034cb1a63f77a3"};